<template>
  <BaseButton
    v-bind="$attrs"
    background-colour="black"
  >
    <template #content>
      <div :class="$b('inner')">
        <div :class="$b('text')">
          <slot />
        </div>
      </div>
    </template>
  </BaseButton>
</template>

<script>
export default {
  name: 'GiftingButton',
  props: {
    outline: { type: Boolean, default: false }
  }
}
</script>

<style lang="postcss">
.GiftingButton {
  @apply mb-sm
    w-full
    relative;

  &__text {
    @apply t-gradient-gold;
  }
}
</style>
